import React from 'react';
import { Text, Card, Button, Link } from '@scale/scaleui-radix';
import { FrontierDataTaskParams } from '@scale/shared/types/frontierData';
import { useExternalAppBaseUrl } from './hooks/useExternalAppUrl';

type AttemptPreview = {
  type: 'pipelinev3humannode';
  nodeId: string;
};

type TaskPreview = {
  type: 'task';
  taskId: string;
};

interface Props {
  params: FrontierDataTaskParams;
  previewParams: AttemptPreview | TaskPreview;
}

const FrontierDataTaskPreview: React.FC<Props> = ({ params, previewParams }) => {
  const baseUrl = useExternalAppBaseUrl({
    externalAppName: params.externalAppName,
  });
  return (
    <div className="h-full flex justify-center items-center">
      <Card>
        <div className="flex flex-col gap-1">
          {previewParams.type === 'pipelinev3humannode' && (
            <>
              <Text size="2" color="neutral">
                Node ID: {previewParams.nodeId}
              </Text>
              <Button asChild size="2">
                <Link href={`${baseUrl}/review/${previewParams.nodeId}`} target="_blank">
                  View in external app
                </Link>
              </Button>
            </>
          )}
          {previewParams.type === 'task' && (
            <>
              <Text size="2" color="neutral">
                Task ID: {previewParams.taskId}
              </Text>
              <Button asChild size="2">
                <Link href={`${baseUrl}/task/${previewParams.taskId}`} target="_blank">
                  View in external app
                </Link>
              </Button>
            </>
          )}
        </div>
      </Card>
    </div>
  );
};

export default FrontierDataTaskPreview;
